import React from 'react';
import { CardElement } from '@stripe/react-stripe-js';
import { css } from '@emotion/react';
import { StripeCardElementChangeEvent } from '@stripe/stripe-js';
import { useFormContext } from 'react-hook-form';
import tw from 'twin.macro';

const StripeCard: React.FC<any> = ({ ...props }) => {
  const formHandlers = useFormContext();

  return (
    <div
      css={css`
        border: 1px solid #a0b1b3;
        ${tw`rounded-input border-color-input-box`}
        min-height: 2.3rem;
        max-height: 35px;
        border-width: 1px;
        width: 100%;
        padding: 0.5rem 0.75rem;
      `}
    >
      <CardElement
        options={{
          hidePostalCode: true,
        }}
        {...props}
        onChange={(event: StripeCardElementChangeEvent) => {
          if (event.error?.message) {
            formHandlers.setError(props.name, { type: 'error', message: event.error?.message });
          } else {
            formHandlers.clearErrors(props.name);
          }
          props.onChange && props.onChange(event);
        }}
      />
    </div>
  );
};

export default StripeCard;
